import { memo } from 'react';
import { useGetDartsQuery } from '~/features/dart';
import useDartBottomSheetStore from '~/store/useDartBottomSheetStore';
import BottomSheetContainer from '../BottomSheet';
import DartBottomSheetInner from './BottomSheetInner';

const DartBottomSheet = memo(() => {
  const { isOpen, setIsOpen } = useDartBottomSheetStore();
  const { data: dartBalance } = useGetDartsQuery();

  return (
    <BottomSheetContainer
      isOpen={isOpen}
      onClose={() => setIsOpen(false)}
      openHeightRates={[1]}
      hideHandle
      disableContentDrag
    >
      <DartBottomSheetInner
        onClose={() => setIsOpen(false)}
        dart={dartBalance ?? 0}
      />
    </BottomSheetContainer>
  );
});

export default DartBottomSheet;
